import { render, staticRenderFns } from "./DialogFormClientEdit.vue?vue&type=template&id=5792a436"
import script from "./DialogFormClientEdit.vue?vue&type=script&lang=js"
export * from "./DialogFormClientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports